/**
 * The API shape is a Record keyed by action name (e.g. `{ myProfile: {...}, listAgents: {...} }`).
 * Older payloads may arrive as an array, so we tolerate both. Action lookups everywhere else
 * key by name via `findAction`.
 */
export function normalizePotentialActions(payload) {
    if (!payload) {
        return {};
    }
    if (Array.isArray(payload)) {
        const result = {};
        for (const entry of payload) {
            if (entry && typeof entry === 'object') {
                const action = entry;
                const key = typeof action.name === 'string' && action.name ? action.name : '';
                if (key)
                    result[key] = action;
            }
        }
        return result;
    }
    if (typeof payload === 'object') {
        return payload;
    }
    return {};
}
